import type { LC } from '@use-gpu/live';
import type { OffscreenRenderContext } from '@use-gpu/core';
import type { OITOptions } from '../../pass/types';

import { use, gather, yeet, memo } from '@use-gpu/live';
import { patch, $set } from '@use-gpu/state';

import { useRenderContext } from '../../providers/render-provider';
import { RenderTarget, getCombinedRenderTarget } from '../render-target';

export type OITBufferProps = {
  oit?: OITOptions,
};

export const OIT_TRANSPARENCY_FORMAT = 'rgba16float';
export const OIT_REVEALAGE_FORMAT = 'r16float';

export const OITBuffer: LC = memo((/*props: OITBufferProps*/) => {

  const renderContext = useRenderContext();
  const {depthStencilState, viewAttachments: [{depthStencilAttachment}]} = renderContext;

  const targets = [
    use(RenderTarget, {
      label: 'OIT/Transparency',
      sampler: null,
      format: OIT_TRANSPARENCY_FORMAT,
      variant: 'textureLoad',
      depthStencil: null,
      colorSpace: 'linear',
      blend: {
        color: { srcFactor: 'one', dstFactor: 'one' },
        alpha: { srcFactor: 'one', dstFactor: 'one' },
      }
    }),
    use(RenderTarget, {
      label: 'OIT/Revealage',
      sampler: null,
      format: OIT_REVEALAGE_FORMAT,
      variant: 'textureLoad',
      depthStencil: null,
      colorSpace: 'linear',
      backgroundColor: [1, 1, 1, 1],
      blend: {
        color: { srcFactor: 'zero', dstFactor: 'one-minus-src-alpha' },
        alpha: { srcFactor: 'zero', dstFactor: 'one-minus-src-alpha' },
      },
    }),
  ];

  return gather(targets, (targets: OffscreenRenderContext[]) => {
    const mrt = getCombinedRenderTarget(targets);
    const mrtDepth = patch(mrt, {
      depthStencilState: $set(patch(depthStencilState, {depthWriteEnabled: false})),
      viewAttachments: {[0]: {depthStencilAttachment: $set(depthStencilAttachment)}}
    });

    return yeet({
      targets: { oit: [mrtDepth] },
    });
  });
}, 'OITBuffer');

export const DEFAULT_OIT_OPTIONS = {
};

export const parseOITOptions = (opt: boolean | Partial<OITOptions>) => ({
  ...DEFAULT_OIT_OPTIONS,
  ...(
    opt === true ? {} : opt
  ),
});
